// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./Home.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./about.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navbar {

  font-family: 'Playfair Display', serif; /* Adjusted font */

}

.img-fluid-carousel {
  width: 25%;
  height: 400px;
  object-fit: cover;
  margin: 0 10px;
  transition: transform 0.3s ease-in-out;
}
.img-fluid-carousel:hover {
  transform: scale(1.1);
}

.hero-container {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center center/cover;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  position: relative;
}

.hero-container::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
}

.img-p {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center center/cover;
}

.hero-content {
  position: relative;
  z-index: 2;
}

.hero-title {
  font-family: 'Playfair Display', serif; /* Adjusted font */
  letter-spacing: 2px;
}

.about-img {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat center center/cover;
  min-height: '300px';
  height: '100%';
}

.order-btn {
  font-family: 'Playfair Display', serif; /* Adjusted font */
  background-color: transparent;
  border: 2px solid white;
  border-radius: 30px;
  padding: 10px 20px;
  font-size: 16px;
  font-weight: bold;
  color: white;
  transition: all 0.3s ease-in-out;
}

.order-btn:hover {
  background-color: white;
  color: black;
}

.menu-box {
  background-color: #E6D5B8;
  transition: transform 0.3s ease-in-out;
}

.menu-box:hover {
  transform: scale(1.05);
}

.parallax-row {
  margin-top: 100px;
  margin-bottom: 100px;
}

@media (max-width: 768px) {
  .parallax-wrapper img {
    width: 100px !important;
    margin: 0 10px !important;
  }

  #quote-section h2 {
    font-size: 2rem !important;
    padding: 0 1rem;
  }

  #quote-section {
    padding: 3rem 0;
  }
}


@media (max-width: 768px) {
  #quote-section {
    min-height: auto !important;
    padding-top: 1rem;
    padding-bottom: 1rem;
    max-width: 768px;
  }

  #quote-section .parallax-wrapper {
    gap: 2rem;
    margin-bottom: 4rem !important;
  }

  #quote-section .parallax-wrapper img {
    width: 150px !important;
    margin: 0 !important;
  }

  #quote-section h2 {
    font-size: 2.5rem !important;
    padding: 0 1rem;
  }
}


/* Desktop */
.dining-main {
  width: 55%;
  z-index: 1;
  top: 45%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.dining-top-left {
  width: 20%;
  z-index: 1;
  top: -10%;
  left: 20%;
  transform: translate(-50%, -50%);
}

.dining-bottom-right {
  width: 45%;
  z-index: 2;
  top: 110%;
  left: 68%;
  transform: translate(-50%, -50%);
}

/* Mobile */
@media (max-width: 768px) {

  .dining-main {
    width: 55%;
    transform: translate(-50%, -50%) scale(0.95);
  }


  .dining-top-left {
    width: 30%;
    top: 20%;
    left: 20%;
    transform: translate(-50%, -50%) scale(0.80);
  }

  .dining-bottom-right {
    width: 50%;
    top: 85%;
    left: 80%;
    transform: translate(-50%, -50%) scale(0.80);
  }

  .dining-text .dining-text {
    font-size: 3.5rem ;
  }

  .dining-text p {
    font-size: 1rem !important;
    width: 90% !important;
  }

  .dining-text a {
    font-size: 1rem;
    padding: 0.5rem 1rem;
  }
}


/* Default: Desktop (4 images per slide) */
.img-fluid-carousel {
  width: 20%;
  height: 400px;
  object-fit: cover;
  margin: 0 10px;
  transition: transform 0.3s ease;
}

/* Tablet: max 2–3 images per slide */
@media (max-width: 992px) {
  .img-fluid-carousel {
    width: 28%;
    height: 300px;
    margin: 0 8px;
  }
}

/* Small screens: 1–2 images per slide */
@media (max-width: 768px) {
  .img-fluid-carousel {
    width: 100%;
    max-height: 150px;
    margin: 0 6px;
  }
}

/* Very small screens: single image per row if needed */
@media (max-width: 480px) {
  .img-fluid-carousel {
    width: 80%;
    height: 200px;
    margin: 0 auto 1rem auto;
    display: block;
  }

  .carousel-item > div.d-flex {
    flex-wrap: wrap;
    justify-content: center;
  }
}

@media (max-width: 768px) {
  .footer {
    font-size: 0.9rem;
  }

  #footer-text {
    font-size: 2.5rem !important;
  }

  .footer p {
    font-size: 0.95rem;
  }
}

@media (max-width: 480px) {
  .footer {
    font-size: 0.8rem;
  }

  #footer-text {
    font-size: 2rem !important;
  }

  .footer p {
    font-size: 0.85rem;
  }
}

@media (max-width: 992px) {
  .hero-title {
    font-size: 3rem !important;
  }

  .hero-content p {
    font-size: 1.25rem !important;
  }

  .hero-buttons .order-btn {
    font-size: 1rem;
    padding: 8px 16px;
  }
}

@media (max-width: 768px) {
  .hero-title {
    font-size: 2.5rem !important;
  }

  .hero-content p {
    font-size: 1rem !important;
  }

  .hero-buttons {
    flex-direction: column;
    gap: 1rem;
  }

  .hero-buttons .order-btn {
    width: 100%;
    text-align: center;
    font-size: 1rem;
  }
}

/* Tablet */
@media (max-width: 992px) {
  #quote-section h2 {
    font-size: clamp(2rem, 6vw, 4.5rem);
  }

  #quote-section .parallax-wrapper {
    flex-wrap: wrap;
    justify-content: center !important;
    gap: 2rem;
  }

  #quote-section .parallax-wrapper img {
    width: 160px !important;
    margin: 0 20px !important;
  }
}

/* Mobile */
@media (max-width: 768px) {
  #quote-section {
    padding: 2rem 1rem !important;
  }

  #quote-section h2 {
    font-size: clamp(1.5rem, 5vw, 3rem) !important;
    padding: 0 1rem;
  }

  #quote-section .parallax-wrapper {
    gap: 2rem;
    margin-bottom: 2rem !important;
    margin-top: 2rem !important;
    flex-wrap: wrap;
    justify-content: center !important;
  }

  #quote-section .parallax-wrapper img {
    width: 120px !important;
    margin: 0 10px !important;
  }
}

/* Very small screens */
@media (max-width: 480px) {
  #quote-section h2 {
    font-size: 1.8rem !important;
    line-height: 1.4;
  }

  #quote-section .parallax-wrapper img {
    width: 90px !important;
  }
}

@media (max-width: 576px) {
  .container h1 {
    font-size: 2rem !important;
  }

  .container h3 {
    font-size: 1.25rem !important;
  }

  .btn {
    font-size: 1rem !important;
    padding: 0.75rem 1rem !important;
  }
}

.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background: rgba(0,0,0,0.4);
  border-radius: 0.375rem; /* Optional: Matches Bootstrap button radius */
  z-index: 10;
}

`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;;EAEE,sCAAsC,EAAE,kBAAkB;;AAE5D;;AAEA;EACE,UAAU;EACV,aAAa;EACb,iBAAiB;EACjB,cAAc;EACd,sCAAsC;AACxC;AACA;EACE,qBAAqB;AACvB;;AAEA;EACE,iFAA2D;EAC3D,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;AAChC;;AAEA;EACE,iFAA2D;AAC7D;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,sCAAsC,EAAE,kBAAkB;EAC1D,mBAAmB;AACrB;;AAEA;EACE,iFAA4D;EAC5D,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,sCAAsC,EAAE,kBAAkB;EAC1D,6BAA6B;EAC7B,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,gCAAgC;AAClC;;AAEA;EACE,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,sCAAsC;AACxC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE;IACE,uBAAuB;IACvB,yBAAyB;EAC3B;;EAEA;IACE,0BAA0B;IAC1B,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;;AAGA;EACE;IACE,2BAA2B;IAC3B,iBAAiB;IACjB,oBAAoB;IACpB,gBAAgB;EAClB;;EAEA;IACE,SAAS;IACT,8BAA8B;EAChC;;EAEA;IACE,uBAAuB;IACvB,oBAAoB;EACtB;;EAEA;IACE,4BAA4B;IAC5B,eAAe;EACjB;AACF;;;AAGA,YAAY;AACZ;EACE,UAAU;EACV,UAAU;EACV,QAAQ;EACR,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,UAAU;EACV,SAAS;EACT,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,UAAU;EACV,SAAS;EACT,SAAS;EACT,gCAAgC;AAClC;;AAEA,WAAW;AACX;;EAEE;IACE,UAAU;IACV,4CAA4C;EAC9C;;;EAGA;IACE,UAAU;IACV,QAAQ;IACR,SAAS;IACT,4CAA4C;EAC9C;;EAEA;IACE,UAAU;IACV,QAAQ;IACR,SAAS;IACT,4CAA4C;EAC9C;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,0BAA0B;IAC1B,qBAAqB;EACvB;;EAEA;IACE,eAAe;IACf,oBAAoB;EACtB;AACF;;;AAGA,0CAA0C;AAC1C;EACE,UAAU;EACV,aAAa;EACb,iBAAiB;EACjB,cAAc;EACd,+BAA+B;AACjC;;AAEA,qCAAqC;AACrC;EACE;IACE,UAAU;IACV,aAAa;IACb,aAAa;EACf;AACF;;AAEA,wCAAwC;AACxC;EACE;IACE,WAAW;IACX,iBAAiB;IACjB,aAAa;EACf;AACF;;AAEA,uDAAuD;AACvD;EACE;IACE,UAAU;IACV,aAAa;IACb,wBAAwB;IACxB,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,4BAA4B;EAC9B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,eAAe;EACjB;AACF;;AAEA,WAAW;AACX;EACE;IACE,mCAAmC;EACrC;;EAEA;IACE,eAAe;IACf,kCAAkC;IAClC,SAAS;EACX;;EAEA;IACE,uBAAuB;IACvB,yBAAyB;EAC3B;AACF;;AAEA,WAAW;AACX;EACE;IACE,6BAA6B;EAC/B;;EAEA;IACE,8CAA8C;IAC9C,eAAe;EACjB;;EAEA;IACE,SAAS;IACT,8BAA8B;IAC9B,2BAA2B;IAC3B,eAAe;IACf,kCAAkC;EACpC;;EAEA;IACE,uBAAuB;IACvB,yBAAyB;EAC3B;AACF;;AAEA,uBAAuB;AACvB;EACE;IACE,4BAA4B;IAC5B,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,0BAA0B;IAC1B,gCAAgC;EAClC;AACF;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,YAAY;EACZ,WAAW;EACX,2BAA2B;EAC3B,uBAAuB,EAAE,8CAA8C;EACvE,WAAW;AACb","sourcesContent":[".navbar {\n\n  font-family: 'Playfair Display', serif; /* Adjusted font */\n\n}\n\n.img-fluid-carousel {\n  width: 25%;\n  height: 400px;\n  object-fit: cover;\n  margin: 0 10px;\n  transition: transform 0.3s ease-in-out;\n}\n.img-fluid-carousel:hover {\n  transform: scale(1.1);\n}\n\n.hero-container {\n  background: url('./Home.jpg') no-repeat center center/cover;\n  height: 100vh;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  position: relative;\n}\n\n.hero-container::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5);\n}\n\n.img-p {\n  background: url('./Home.jpg') no-repeat center center/cover;\n}\n\n.hero-content {\n  position: relative;\n  z-index: 2;\n}\n\n.hero-title {\n  font-family: 'Playfair Display', serif; /* Adjusted font */\n  letter-spacing: 2px;\n}\n\n.about-img {\n  background: url(\"./about.jpg\") no-repeat center center/cover;\n  min-height: '300px';\n  height: '100%';\n}\n\n.order-btn {\n  font-family: 'Playfair Display', serif; /* Adjusted font */\n  background-color: transparent;\n  border: 2px solid white;\n  border-radius: 30px;\n  padding: 10px 20px;\n  font-size: 16px;\n  font-weight: bold;\n  color: white;\n  transition: all 0.3s ease-in-out;\n}\n\n.order-btn:hover {\n  background-color: white;\n  color: black;\n}\n\n.menu-box {\n  background-color: #E6D5B8;\n  transition: transform 0.3s ease-in-out;\n}\n\n.menu-box:hover {\n  transform: scale(1.05);\n}\n\n.parallax-row {\n  margin-top: 100px;\n  margin-bottom: 100px;\n}\n\n@media (max-width: 768px) {\n  .parallax-wrapper img {\n    width: 100px !important;\n    margin: 0 10px !important;\n  }\n\n  #quote-section h2 {\n    font-size: 2rem !important;\n    padding: 0 1rem;\n  }\n\n  #quote-section {\n    padding: 3rem 0;\n  }\n}\n\n\n@media (max-width: 768px) {\n  #quote-section {\n    min-height: auto !important;\n    padding-top: 1rem;\n    padding-bottom: 1rem;\n    max-width: 768px;\n  }\n\n  #quote-section .parallax-wrapper {\n    gap: 2rem;\n    margin-bottom: 4rem !important;\n  }\n\n  #quote-section .parallax-wrapper img {\n    width: 150px !important;\n    margin: 0 !important;\n  }\n\n  #quote-section h2 {\n    font-size: 2.5rem !important;\n    padding: 0 1rem;\n  }\n}\n\n\n/* Desktop */\n.dining-main {\n  width: 55%;\n  z-index: 1;\n  top: 45%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n\n.dining-top-left {\n  width: 20%;\n  z-index: 1;\n  top: -10%;\n  left: 20%;\n  transform: translate(-50%, -50%);\n}\n\n.dining-bottom-right {\n  width: 45%;\n  z-index: 2;\n  top: 110%;\n  left: 68%;\n  transform: translate(-50%, -50%);\n}\n\n/* Mobile */\n@media (max-width: 768px) {\n\n  .dining-main {\n    width: 55%;\n    transform: translate(-50%, -50%) scale(0.95);\n  }\n\n\n  .dining-top-left {\n    width: 30%;\n    top: 20%;\n    left: 20%;\n    transform: translate(-50%, -50%) scale(0.80);\n  }\n\n  .dining-bottom-right {\n    width: 50%;\n    top: 85%;\n    left: 80%;\n    transform: translate(-50%, -50%) scale(0.80);\n  }\n\n  .dining-text .dining-text {\n    font-size: 3.5rem ;\n  }\n\n  .dining-text p {\n    font-size: 1rem !important;\n    width: 90% !important;\n  }\n\n  .dining-text a {\n    font-size: 1rem;\n    padding: 0.5rem 1rem;\n  }\n}\n\n\n/* Default: Desktop (4 images per slide) */\n.img-fluid-carousel {\n  width: 20%;\n  height: 400px;\n  object-fit: cover;\n  margin: 0 10px;\n  transition: transform 0.3s ease;\n}\n\n/* Tablet: max 2–3 images per slide */\n@media (max-width: 992px) {\n  .img-fluid-carousel {\n    width: 28%;\n    height: 300px;\n    margin: 0 8px;\n  }\n}\n\n/* Small screens: 1–2 images per slide */\n@media (max-width: 768px) {\n  .img-fluid-carousel {\n    width: 100%;\n    max-height: 150px;\n    margin: 0 6px;\n  }\n}\n\n/* Very small screens: single image per row if needed */\n@media (max-width: 480px) {\n  .img-fluid-carousel {\n    width: 80%;\n    height: 200px;\n    margin: 0 auto 1rem auto;\n    display: block;\n  }\n\n  .carousel-item > div.d-flex {\n    flex-wrap: wrap;\n    justify-content: center;\n  }\n}\n\n@media (max-width: 768px) {\n  .footer {\n    font-size: 0.9rem;\n  }\n\n  #footer-text {\n    font-size: 2.5rem !important;\n  }\n\n  .footer p {\n    font-size: 0.95rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .footer {\n    font-size: 0.8rem;\n  }\n\n  #footer-text {\n    font-size: 2rem !important;\n  }\n\n  .footer p {\n    font-size: 0.85rem;\n  }\n}\n\n@media (max-width: 992px) {\n  .hero-title {\n    font-size: 3rem !important;\n  }\n\n  .hero-content p {\n    font-size: 1.25rem !important;\n  }\n\n  .hero-buttons .order-btn {\n    font-size: 1rem;\n    padding: 8px 16px;\n  }\n}\n\n@media (max-width: 768px) {\n  .hero-title {\n    font-size: 2.5rem !important;\n  }\n\n  .hero-content p {\n    font-size: 1rem !important;\n  }\n\n  .hero-buttons {\n    flex-direction: column;\n    gap: 1rem;\n  }\n\n  .hero-buttons .order-btn {\n    width: 100%;\n    text-align: center;\n    font-size: 1rem;\n  }\n}\n\n/* Tablet */\n@media (max-width: 992px) {\n  #quote-section h2 {\n    font-size: clamp(2rem, 6vw, 4.5rem);\n  }\n\n  #quote-section .parallax-wrapper {\n    flex-wrap: wrap;\n    justify-content: center !important;\n    gap: 2rem;\n  }\n\n  #quote-section .parallax-wrapper img {\n    width: 160px !important;\n    margin: 0 20px !important;\n  }\n}\n\n/* Mobile */\n@media (max-width: 768px) {\n  #quote-section {\n    padding: 2rem 1rem !important;\n  }\n\n  #quote-section h2 {\n    font-size: clamp(1.5rem, 5vw, 3rem) !important;\n    padding: 0 1rem;\n  }\n\n  #quote-section .parallax-wrapper {\n    gap: 2rem;\n    margin-bottom: 2rem !important;\n    margin-top: 2rem !important;\n    flex-wrap: wrap;\n    justify-content: center !important;\n  }\n\n  #quote-section .parallax-wrapper img {\n    width: 120px !important;\n    margin: 0 10px !important;\n  }\n}\n\n/* Very small screens */\n@media (max-width: 480px) {\n  #quote-section h2 {\n    font-size: 1.8rem !important;\n    line-height: 1.4;\n  }\n\n  #quote-section .parallax-wrapper img {\n    width: 90px !important;\n  }\n}\n\n@media (max-width: 576px) {\n  .container h1 {\n    font-size: 2rem !important;\n  }\n\n  .container h3 {\n    font-size: 1.25rem !important;\n  }\n\n  .btn {\n    font-size: 1rem !important;\n    padding: 0.75rem 1rem !important;\n  }\n}\n\n.loading-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 100%;\n  width: 100%;\n  background: rgba(0,0,0,0.4);\n  border-radius: 0.375rem; /* Optional: Matches Bootstrap button radius */\n  z-index: 10;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
